export const SET_ACTIVE_TICKET = "SET_ACTIVE_TICKET"
export const UPDATE_TICKET = "UPDATE_TICKET"